import { useMemo, type ReactNode } from "react";
import { cn } from "~/lib/utils";

interface RowProps {
  count: "two" | "three";
  children: Readonly<ReactNode>;
}

export default function Row({ children, count }: RowProps) {
  const rowStyle = useMemo(() => {
    if (count == "two") {
      return "sm:grid-cols-2"
    }

    if (count == "three") {
      return "sm:grid-cols-3"
    }

    return ""
  }, [count]);

  return (
    <div className={cn("grid grid-cols-1 gap-5", rowStyle)}>{children}</div>
  );
}
